import { createPageApp } from '@/lib/createPageApp'
import ParentCabinetPage from './ParentCabinetPage.vue'

createPageApp(ParentCabinetPage).mount()
